import React from "react";
import { isoToFormatDate } from "../../functions/formatTime";
import Row from "../common/List/Row";
import { getMethodText } from "../../functions/history";

export default function HistoryRow({ history }) {
  const cellTexts = [
    isoToFormatDate(history.createdAt, "yyyy/MM/dd HH:mm"),
    history.name,
    getMethodText(history),
  ];

  const noteTexts = [history.path, history.objectBefore, history.objectAfter];

  const cellAlign = ["C", "L", "C"];

  return (
    <Row cellTexts={cellTexts} noteTexts={noteTexts} cellAlign={cellAlign} />
  );
}
